export const promoTemplateSettings = {
    purchaseOrderMatchingSettings: {
        autoMarkingPurchaseOrderAsBilledEnabled: true,
        autoUnmarkingPurchaseOrderAsBilledEnabled: true,
    },
};
